// extracted by mini-css-extract-plugin
export var content = "_mv-1";
export var fullScreen = "_mv-0";